import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "arrayFilter",
})
export class ArrayFilterPipe implements PipeTransform {
    /**
     * filter array
     *
     * @param arr
     * @param query
     * @param args
     * @returns
     */
    transform(arr: any[], query: string, ...args: string[]): any[] {
        // empty array should return empty
        if (!arr || arr.length < 1) {
            return [];
        }

        // empty query should not modify array
        if (!query) {
            return arr;
        }

        const [filters] = args;

        let filterQueries = [];

        // filter should be input from parameters or should be spreaded from array first element
        if (filters) {
            filterQueries = filters.split(",");
        } else {
            const [first] = arr;
            filterQueries = Object.keys(first);
        }

        const result = [];
        // filter array from queries list
        if (filterQueries?.length > 0) {
            filterQueries.forEach((f: string) => {
                arr.forEach(e => {
                    if (
                        e.hasOwnProperty(f) &&
                        e[f] &&
                        e[f]?.toString().toLowerCase().includes(query.toLowerCase()) &&
                        result.findIndex(r => e === r) < 0
                    ) {
                        result.push(e);
                    }
                });
            });
        }
        return result;
    }
}
